export function isDisposable(thing) {
    return !!thing && typeof thing.dispose === 'function';
}
//# sourceMappingURL=dispose.js.map